import { SignInRoute } from "./SignInRoute";
import { SignInCenteredLayout } from "./layouts/SignInCenteredLayout";
import { SignInForm } from "./SignInForm";

export function SignInCenteredPage() {
  return (
    <SignInRoute>
      <SignInCenteredLayout>
        <SignInForm />
      </SignInCenteredLayout>
    </SignInRoute>
  );
}
